module.exports = __webpack_public_path__ + "img/pc-cn-4.97c9d881.gif";